import {
  closeViewEditDialog,
  fetchAllInstantPrize,
  openCreationDialog,
  openPrizeDialogV2,
  openViewEditDialog,
  publishInstantLuckyDraw,
} from "modules/instant-lucky-draw/redux";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import InstantLuckyDrawTableComponent from "./instantLuckyDrawTable.component";
import {
  setType,
  fetchInstantLuckyDrawDetail,
  fetchJSONURL,
  openPrizeDialog,
  openAllocationDialog,
  fetchAllInstantPrizeLegacy,
  openWinnerDialog,
  changeInstantLuckyDrawProgress,
} from "modules/instant-lucky-draw/redux";
import { hideBackdrop, showBackdrop } from "modules/backdrop";
import { unwrapResult } from "@reduxjs/toolkit";
import {
  ViewEditInstantLuckyDrawDialog,
  PrizeAllocationDialog,
  WinnerDialog,
} from "../../dialog";
import { ROOT } from "../../../config/instant-lucky-draw.route";
import { useHistory } from "react-router-dom";
import getWinnerExcel from "app/api/instantLuckyDraw/getWinnerExcel.api";
import { progressStatus } from "lib/constants/instantLuckyDrawProgress";
import ConfirmationDialogComponent from "components/dialog/confirmation";
import { getLang } from "app/feature/constants";
import {canAccess} from "../../../../profile/redux/selector/profile.selector";
import {AccessRights} from "../../../../../lib/constants/accessRights";

export default function InstantLuckyDrawTableContainer({
  hasInstantLuckyDrawAddAccessRight,
  hasInstantLuckyDrawEditAccessRight,
  hasInstantLuckyDrawActivateOrDeactivateAccessRight,
  isFetching,
  data,
  rowsPerPage,
  page,
  search,
  handlePageChange,
  handleRowPerPageChange,
  totalRecords,
  handleStatusChange,
  handleFetchInstantLuckyDrawList,
  paginationOptions,
}) {
  const dispatch = useDispatch();
  const history = useHistory();
  const accessToken = useSelector((state) => state.session.accessToken);
  const [confirmationDialogModal, setConfirmationDialogModal] = useState(false);
  const isLoadingInstantError = useSelector(
    (state) => state.instantLuckyDraw.isLoadingInstantError
  );
  const lang = useSelector((state) => state.constant.languages);
  const language = useSelector((state) => state.profile.language);

  const [selectedIld, setSelectedIld] = useState(null);

  const canEditName = useSelector((state) => canAccess(state, AccessRights.Campaign.INSTANT_LUCKY_DRAW_WRITE_UPDATE_NAME));
  const canEditPeriod = useSelector((state) => canAccess(state, AccessRights.Campaign.INSTANT_LUCKY_DRAW_WRITE_UPDATE_PERIOD));
  const canEditDesc = useSelector((state) => canAccess(state, AccessRights.Campaign.INSTANT_LUCKY_DRAW_WRITE_UPDATE_DESCRIPTION));
  const canEditImage = useSelector((state) => canAccess(state, AccessRights.Campaign.INSTANT_LUCKY_DRAW_WRITE_UPDATE_IMAGE));
  const canEditAssignProduct = useSelector((state) => canAccess(state, AccessRights.Campaign.INSTANT_LUCKY_DRAW_WRITE_UPDATE_ASSIGN_PRODUCT));
  const canEditTnc = useSelector((state) => canAccess(state, AccessRights.Campaign.INSTANT_LUCKY_DRAW_WRITE_UPDATE_TNC));
  const canEditTemplate = useSelector((state) => canAccess(state, AccessRights.Campaign.INSTANT_LUCKY_DRAW_WRITE_UPDATE_GAME_TEMPLATE));
  const canEditForm = useSelector((state) => canAccess(state, AccessRights.Campaign.INSTANT_LUCKY_DRAW_WRITE_UPDATE_REGISTRATION_FORM));
  const canSetPrize = useSelector((state) => canAccess(state, AccessRights.Campaign.INSTANT_LUCKY_DRAW_WRITE_PRIZE));
  const canReadPrize = useSelector((state) => canAccess(state, AccessRights.Campaign.INSTANT_LUCKY_DRAW_WRITE_PRIZE_READ));
  const canWritePrize = useSelector((state) => canAccess(state, AccessRights.Campaign.INSTANT_LUCKY_DRAW_WRITE_PRIZE_WRITE));
  const canDeletePrize = useSelector((state) => canAccess(state, AccessRights.Campaign.INSTANT_LUCKY_DRAW_WRITE_PRIZE_DELETE));
  const canSetWinner = useSelector((state) => canAccess(state, AccessRights.Campaign.INSTANT_LUCKY_DRAW_WRITE_WINNER));
  const canReadWinner = useSelector((state) => canAccess(state, AccessRights.Campaign.INSTANT_LUCKY_DRAW_WRITE_WINNER_READ));
  const canWriteWinner = useSelector((state) => canAccess(state, AccessRights.Campaign.INSTANT_LUCKY_DRAW_WRITE_WINNER_WRITE));
  const canPublish = useSelector((state) => canAccess(state, AccessRights.Campaign.INSTANT_LUCKY_DRAW_WRITE_PUBLISH));


  const handleCreate = () => {
    dispatch(openCreationDialog());
  };

  const handleView = async (id) => {
    dispatch(setType({ index: -1, type: "view" }));
    dispatch(showBackdrop());

    dispatch(fetchInstantLuckyDrawDetail(id))
      .then(unwrapResult)
      .then(async (response) => {
        if (response.tnc_url.substr(response.tnc_url.length - 3) !== "pdf") {
          await dispatch(fetchJSONURL(response.tnc_url))
            .then(unwrapResult)
            .then(() => {
              dispatch(hideBackdrop());
              dispatch(openViewEditDialog());
            });
        } else {
          dispatch(hideBackdrop());
          dispatch(openViewEditDialog());
        }
      })
      .catch((error) => {
        dispatch(hideBackdrop());
        dispatch(closeViewEditDialog());
        return;
      });
  };

  async function handleViewParticipants(id) {
    history.push(`${ROOT}/View/${id}`);
  }

  async function handleViewPrize(item, dialogCategory) {
    dispatch(showBackdrop());

    setSelectedIld(item);

    const fetchPrizeTableInfo = {
      type: "dialog",
      instantLuckyDrawId: item.id,
      isWinnerShow: dialogCategory === "winner" ? 1 : 0,
    };

    let isCurrent = item && item.type === "current";

    await dispatch(
      isCurrent
        ? fetchAllInstantPrize(fetchPrizeTableInfo)
        : fetchAllInstantPrizeLegacy(fetchPrizeTableInfo)
    )
      .then(unwrapResult)
      .then(() => {
        dispatch(hideBackdrop());

        if (dialogCategory === "prize") {
          if (isCurrent) {
            dispatch(
              openPrizeDialogV2({ type: "view", instantLuckyDraw: item })
            );
          } else {
            dispatch(openPrizeDialog({ type: "view" }));
          }
        } else if (dialogCategory === "winner") {
          dispatch(setType({ index: 3, type: "view" }));
          dispatch(openWinnerDialog());
        }
      })
      .catch((error) => {
        dispatch(hideBackdrop());
        return;
      });
  }

  async function handleViewTemplate(id, progress) {
    dispatch(showBackdrop());
    dispatch(hideBackdrop());
    dispatch(openAllocationDialog());
  }

  const handleDownloadWinner = (id) => {
    dispatch(showBackdrop());
    getWinnerExcel.get({ id: id, token: accessToken }).finally(() => {
      dispatch(hideBackdrop());
      return;
    });
  };

  const handlePublished = (item) => {
    setSelectedIld(item);
    setConfirmationDialogModal(true);
  };

  async function handleChangeProgress() {
    dispatch(showBackdrop());
    await dispatch(
      selectedIld.type === "current"
        ? publishInstantLuckyDraw({ id: selectedIld.id })
        : changeInstantLuckyDrawProgress({
            id: selectedIld.id,
            progress: progressStatus.published,
          })
    ).finally(() => {
      dispatch(hideBackdrop());
      setConfirmationDialogModal(false);
    });
  }

  return (
    <>
      <InstantLuckyDrawTableComponent
        hasInstantLuckyDrawAddAccessRight={hasInstantLuckyDrawAddAccessRight}
        hasInstantLuckyDrawEditAccessRight={hasInstantLuckyDrawEditAccessRight}
        hasInstantLuckyDrawActivateOrDeactivateAccessRight={
          hasInstantLuckyDrawActivateOrDeactivateAccessRight
        }
        canEditName={canEditName}
        canEditPeriod={canEditPeriod}
        canEditDesc={canEditDesc}
        canEditImage={canEditImage}
        canEditAssignProduct={canEditAssignProduct}
        canEditTnc={canEditTnc}
        canEditTemplate={canEditTemplate}
        canEditForm={canEditForm}
        canSetPrize={canSetPrize}
        canReadPrize={canReadPrize}
        canWritePrize={canWritePrize}
        canDeletePrize={canDeletePrize}
        canSetWinner={canSetWinner}
        canReadWinner={canReadWinner}
        canWriteWinner={canWriteWinner}
        canPublish={canPublish}
        isFetching={isFetching}
        data={data}
        rowsPerPage={rowsPerPage}
        page={page}
        search={search}
        handlePageChange={handlePageChange}
        handleRowPerPageChange={handleRowPerPageChange}
        totalRecords={totalRecords}
        handleStatusChange={handleStatusChange}
        handleCreate={handleCreate}
        handleView={handleView}
        handleViewParticipants={handleViewParticipants}
        handleViewPrize={handleViewPrize}
        handleViewTemplate={handleViewTemplate}
        handleDownloadWinner={handleDownloadWinner}
        handlePublished={handlePublished}
        handleReload={handleFetchInstantLuckyDrawList}
        isLoadingInstantError={isLoadingInstantError}
        paginationOptions={paginationOptions}
        lang={lang}
        language={language}
      />
      <ViewEditInstantLuckyDrawDialog
        handleClose={() => dispatch(closeViewEditDialog())}
        canEditName={canEditName}
        canEditPeriod={canEditPeriod}
        canEditDesc={canEditDesc}
        canEditImage={canEditImage}
        canEditAssignProduct={canEditAssignProduct}
        canEditTnc={canEditTnc}
        canEditTemplate={canEditTemplate}
        canEditForm={canEditForm}
      />
      <PrizeAllocationDialog />
      <WinnerDialog instantLuckyDraw={selectedIld} />
      <ConfirmationDialogComponent
        isOpen={confirmationDialogModal}
        handleClose={() => setConfirmationDialogModal(false)}
        handleProceed={handleChangeProgress}
        type={"success"}
        remark={getLang(lang, "paragraph.PUBLISH_ILD_REMARK")}
        description={getLang(lang, "paragraph.PLEASE_CONFIRM")}
        title={getLang(lang, "paragraph.PUBLISH_ILD_QUESTION")}
      />
    </>
  );
}
